"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _http = require("@/config/http");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BaseService = /*#__PURE__*/function () {
  function BaseService(resource) {
    _classCallCheck(this, BaseService);
    this.http = _http.http;
    this.resource = resource;
  }
  _createClass(BaseService, [{
    key: "get",
    value: function get(params, config) {
      var request = this.resource;
      var options;
      if (typeof params === 'string' || typeof params === 'number') {
        // Ex. GET /resource/featured
        request = "".concat(this.resource, "/").concat(params);
        options = config;
      } else {
        // Ex. GET /resource?featured=1&active=1
        options = {
          params: params
        };
      }
      return _http.http.get(request, options);
    }
  }, {
    key: "patch",
    value: function patch(body, route) {
      var resource = this.resource;
      if (_lodash.default.isEmpty(route) === false) {
        resource = "".concat(this.resource, "/").concat(route);
      }
      return _http.http.patch(resource, body);
    }
  }, {
    key: "post",
    value: function post(body, route, config) {
      var resource = this.resource;
      if (_lodash.default.isEmpty(route) === false) {
        resource = "".concat(this.resource, "/").concat(route);
      }
      return _http.http.post(resource, body, config);
    }
  }, {
    key: "put",
    value: function put(body, route) {
      var resource = this.resource;
      if (_lodash.default.isEmpty(route) === false) {
        resource = "".concat(this.resource, "/").concat(route);
      }
      return _http.http.put(resource, body);
    }
  }, {
    key: "delete",
    value: function _delete(params) {
      var request = this.resource;
      var options;
      if (typeof params === 'string') {
        // Ex. DELETE /resource/featured
        request = "".concat(this.resource, "/").concat(params);
      } else {
        // Ex. DELETE /resource?featured=1&active=1
        options = {
          params: params
        };
      }
      return _http.http.delete(request, options);
    }
  }]);
  return BaseService;
}();
var _default = BaseService;
exports.default = _default;